import axios from '../utils/axios';

export default function deactivateSeekerPlan(adminId, body) {
    return axios.post(`/admin/${adminId}/jobseeker-admin/v2/admin-recruiter/deactivatesubscription`, body);
};